var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"ma-3 pa-3",attrs:{"flat":"","color":"white"}},[_c('vue-dropzone',{ref:"myVueDropzone",attrs:{"id":"dropzone","options":_vm.dropzoneOptions}}),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"primary"},nativeOn:{"click":function($event){return _vm.saveFile.apply(null, arguments)}}},[_vm._v("Load")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }